import { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/joy/IconButton';

import './SuccessModal.css';

export const SuccessModal = ({ count = 6, closeSuccessModal }) => {
  const [counter, setCounter] = useState(count);

  useEffect(() => {
    if (counter === 0) {
      closeSuccessModal();
    } else {
      const timeout = setTimeout(() => {
        setCounter((counter) => counter - 1);
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [closeSuccessModal, counter]);

  const handleCloseModal = () => {
    setCounter(0);
  };

  return (
    <div className="success-modal-container">
      <IconButton onClick={handleCloseModal} sx={{ position: 'absolute', top: '20px', right: '20px' }} variant="plain">
        <CloseIcon />
      </IconButton>
      <p className="success-modal-title">URL testing has started</p>
      <p className="success-modal-subtitle">when the test is over you will get an email notification</p>
      <p className="success-modal-time-left">the window will close in {counter} seconds</p>
      <button onClick={handleCloseModal} className="success-modal-btn">
        Close
      </button>
    </div>
  );
};
